import {Component, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {QualityCheck} from "../../../../api";
import {StateConfigService} from "../../../../services/state/state-config.service";
import {StepperComponent} from "../../../util/design/stepper/stepper.component";
import {CdkStep} from "@angular/cdk/stepper";

@Component({
  selector: 'app-quality-stepper',
  templateUrl: './quality-stepper.component.html',
  styleUrls: ['./quality-stepper.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    StepperComponent,
    CdkStep
  ]
})
export class QualityStepperComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private stateConfigService = inject(StateConfigService);

  @Input() selectedStep = 0;
  @Output() selectedStepChange = new EventEmitter<number>();

  @Input() isCheckView: boolean = false;
  @Input() isDocView: boolean = false;
  @Input() nextStepAllowed: boolean = false;
  @Input() previousStepAllowed: boolean = false;
  @Input() linear: boolean = true;

  @Output() changeDrivenEvent = new EventEmitter<number>();

  qualityCheck!: QualityCheck
  stepTooltips: (string | undefined)[] = [];

  private readonly disabledComplianceStepTooltip = 'Nur für Prüfungen mit mindestens 2 Dateien verfügbar';

  ngOnInit(): void {
    this.qualityCheck = this.activatedRoute.snapshot.parent!.data.qualityCheck;
    this.updateStepperConfiguration();
  }

  isStepDisabled(index: number): boolean {
    return !this.isCheckView && index === 0 && !this.hasComplianceCheck();
  }

  changeStep(index: number): void {
    if (this.isStepDisabled(index)) {
      return;
    }

    this.selectedStep = index;
    this.selectedStepChange.emit(this.selectedStep);
    this.changeDrivenEvent.emit(index);

    if (!this.isCheckView) {
      if (index == 0) {
        this.router.navigate(['projects', this.stateConfigService.getProjectId(), 'quality', this.qualityCheck.id, 'report', 'compliance']);
      } else if (index == 1) {
        this.router.navigate(['projects', this.stateConfigService.getProjectId(), 'quality', this.qualityCheck.id, 'report']);
      }
    }
  }

  private updateStepperConfiguration(): void {
    if (this.isCheckView) {
      this.stepTooltips = [];
      return;
    }

    this.stepTooltips = [this.hasComplianceCheck() ? undefined : this.disabledComplianceStepTooltip, undefined];
  }

  private hasComplianceCheck(): boolean {
    const extractionIds = new Set(
      (this.qualityCheck.complianceResult ?? [])
        .flatMap(complianceResult => complianceResult.documents ?? [])
        .map(document => document.extractionId)
        .filter((extractionId): extractionId is string => !!extractionId)
    );

    if (extractionIds.size > 0) {
      return extractionIds.size > 1;
    }

    return (this.qualityCheck.qualityCheckProjectFiles?.length ?? 0) > 1;
  }


}
